import * as type from '../../../actions/index.types'

export function VendorReducers(state = {
    loading: false,
    vendorCategoriesLoading: false,
    vendorCategoriesData: null,
    // Vendor bulk Excel upload
    bulkUploadVendorsLoading: false,
    bulkUploadVendorsResult: null, // { total, createdCount, failedCount, created, failed }
    bulkUploadVendorsError: null,
    // Vendor Bill bulk Excel upload
    bulkUploadVendorBillsLoading: false,
    bulkUploadVendorBillsResult: null,
    bulkUploadVendorBillsError: null,
    // Vendor Payment bulk Excel upload
    bulkUploadVendorPaymentsLoading: false,
    bulkUploadVendorPaymentsResult: null,
    bulkUploadVendorPaymentsError: null,
    createVendorCategoryLoading: false,
    updateVendorCategoryLoading: false,
    deleteVendorCategoryLoading: false,
    createVendorLoading: false,
    updateVendorLoading: false,
    deleteVendorLoading: false,
    vendorDetailsLoading: false,
    vendorDetailsData: null,
    vendorsListLoading: false,
    vendorsListData: null,
    vendorsPagination: null,
    allVendorsLoading: false,
    allVendorsData: null,
    vendorsDropdownLoading: false,
    vendorsDropdownData: null,
    // Vendor Setting
    vendorSettingLoading: false,
    vendorSettingData: null,
    // Vendor Tariffs
    vendorTariffsLoading: false,
    vendorTariffsData: null,
    createVendorTariffLoading: false,
    deleteVendorTariffLoading: false,
    allVendorTariffsLoading: false,
    allVendorTariffsData: null,
    // Vendor Bills
    vendorBillsListLoading: false,
    vendorBillsListData: null,
    vendorBillsPagination: null,
    vendorBillDetailsLoading: false,
    vendorBillDetailsData: null,
    createVendorBillLoading: false,
    createVendorBillsBatchLoading: false,
    createVendorBillsBatchResult: null,
    createVendorBillsBatchError: null,
    updateVendorBillLoading: false,
    deleteVendorBillLoading: false,
    approveVendorBillLoading: false,
    payVendorBillLoading: false,
    // Vendor Bank Accounts
    vendorBankAccountsLoading: false,
    vendorBankAccountsData: null,
    createVendorBankAccountLoading: false,
    updateVendorBankAccountLoading: false,
    deleteVendorBankAccountLoading: false,
    // Vendor AMC Tracker
    vendorAmcListLoading: false,
    vendorAmcListData: null,
    vendorAmcDetailsLoading: false,
    vendorAmcDetailsData: null,
    createVendorAmcLoading: false,
    updateVendorAmcLoading: false,
    deleteVendorAmcLoading: false,
    // Vendor GL Codes
    vendorGlCodesLoading: false,
    vendorGlCodesData: null,
    // Vendor GL Code Dropdown
    vendorGlCodeDropdownLoading: false,
    vendorGlCodeDropdownData: null,
    // Vendor Round Off GL Code
    vendorRoundOffGlLoading: false,
    vendorRoundOffGlData: null,
    // Vendor Billing Settings
    saveVendorBillingSettingsLoading: false,
    // Vendor Payments
    vendorPaymentsListLoading: false,
    vendorPaymentsListData: null,
    vendorPaymentsPagination: null,
    vendorPaymentDetailsLoading: false,
    vendorPaymentDetailsData: null,
    createVendorPaymentLoading: false,
    updateVendorPaymentLoading: false,
    deleteVendorPaymentLoading: false,
    vendorUnpaidBillsLoading: false,
    vendorUnpaidBillsData: null,
    error: null
}, action) {

    switch (action.type) {
        // Get Vendor Categories
        case type.SOCIETY_GET_VENDOR_CATEGORIES:
            return {
                ...state,
                vendorCategoriesLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_CATEGORIES_SUCCESS: {
            return {
                ...state,
                error: null,
                vendorCategoriesLoading: false,
                vendorCategoriesData: action.payload?.rows || action.payload?.categories || action.payload,
            }
        }
        case type.SOCIETY_GET_VENDOR_CATEGORIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorCategoriesLoading: false,
            }

        // Create Vendor Category
        case type.SOCIETY_CREATE_VENDOR_CATEGORY:
            return {
                ...state,
                createVendorCategoryLoading: true,
                error: null,
            }
        case type.SOCIETY_CREATE_VENDOR_CATEGORY_SUCCESS: {
            return {
                ...state,
                error: null,
                createVendorCategoryLoading: false,
            }
        }
        case type.SOCIETY_CREATE_VENDOR_CATEGORY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createVendorCategoryLoading: false,
            }

        // Update Vendor Category
        case type.SOCIETY_UPDATE_VENDOR_CATEGORY:
            return { ...state, updateVendorCategoryLoading: true, error: null }
        case type.SOCIETY_UPDATE_VENDOR_CATEGORY_SUCCESS:
            return { ...state, updateVendorCategoryLoading: false, error: null }
        case type.SOCIETY_UPDATE_VENDOR_CATEGORY_FAILURE:
            return { ...state, updateVendorCategoryLoading: false, error: action?.message || 'Something went wrong.' }

        // Delete Vendor Category
        case type.SOCIETY_DELETE_VENDOR_CATEGORY:
            return { ...state, deleteVendorCategoryLoading: true, error: null }
        case type.SOCIETY_DELETE_VENDOR_CATEGORY_SUCCESS:
            return { ...state, deleteVendorCategoryLoading: false, error: null }
        case type.SOCIETY_DELETE_VENDOR_CATEGORY_FAILURE:
            return { ...state, deleteVendorCategoryLoading: false, error: action?.message || 'Something went wrong.' }

        // Create Vendor
        case type.SOCIETY_CREATE_VENDOR:
            return {
                ...state,
                createVendorLoading: true,
                error: null,
            }
        case type.SOCIETY_CREATE_VENDOR_SUCCESS: {
            return {
                ...state,
                error: null,
                createVendorLoading: false,
            }
        }
        case type.SOCIETY_CREATE_VENDOR_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createVendorLoading: false,
            }

        // Get Vendor Details
        case type.SOCIETY_GET_VENDOR_DETAILS:
            return {
                ...state,
                vendorDetailsLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                vendorDetailsLoading: false,
                vendorDetailsData: action.payload,
            }
        }
        case type.SOCIETY_GET_VENDOR_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorDetailsLoading: false,
            }

        // Get Vendors List
        case type.SOCIETY_GET_VENDORS_LIST:
            return {
                ...state,
                vendorsListLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDORS_LIST_SUCCESS: {
            // Saga now dispatches { data, meta }. The BE returns rows in `data`
            // and pagination in `meta.pagination`. Fallbacks below cover the
            // rare cases where a caller still passes the flat shape.
            const rows = action.payload?.data?.rows || action.payload?.data || action.payload?.rows || action.payload;
            const paginationMeta = action.payload?.meta?.pagination;
            const fallbackTotal = action.payload?.count || action.payload?.total || (Array.isArray(rows) ? rows.length : 0);
            return {
                ...state,
                error: null,
                vendorsListLoading: false,
                vendorsListData: rows,
                vendorsPagination: paginationMeta || {
                    total: fallbackTotal,
                    totalPages: Math.ceil(fallbackTotal / 10)
                },
            }
        }
        case type.SOCIETY_GET_VENDORS_LIST_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorsListLoading: false,
            }

        // Update Vendor
        case type.SOCIETY_UPDATE_VENDOR:
            return {
                ...state,
                updateVendorLoading: true,
                error: null,
            }
        case type.SOCIETY_UPDATE_VENDOR_SUCCESS: {
            return {
                ...state,
                error: null,
                updateVendorLoading: false,
            }
        }
        case type.SOCIETY_UPDATE_VENDOR_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateVendorLoading: false,
            }

        // Delete Vendor
        case type.SOCIETY_DELETE_VENDOR:
            return {
                ...state,
                deleteVendorLoading: true,
                error: null,
            }
        case type.SOCIETY_DELETE_VENDOR_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteVendorLoading: false,
            }
        }
        case type.SOCIETY_DELETE_VENDOR_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteVendorLoading: false,
            }

        // Get All Vendors (for dropdowns)
        case type.SOCIETY_GET_ALL_VENDORS:
            return {
                ...state,
                allVendorsLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_ALL_VENDORS_SUCCESS: {
            return {
                ...state,
                error: null,
                allVendorsLoading: false,
                allVendorsData: action.payload,
            }
        }
        case type.SOCIETY_GET_ALL_VENDORS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                allVendorsLoading: false,
            }

        // ============ VENDOR SETTING ============

        // Get Vendor Setting
        case type.SOCIETY_GET_VENDOR_SETTING:
            return {
                ...state,
                vendorSettingLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_SETTING_SUCCESS: {
            return {
                ...state,
                error: null,
                vendorSettingLoading: false,
                vendorSettingData: action.payload,
            }
        }
        case type.SOCIETY_GET_VENDOR_SETTING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorSettingLoading: false,
            }

        // ============ VENDOR TARIFFS ============

        // Get Vendor Tariffs
        case type.SOCIETY_GET_VENDOR_TARIFFS:
            return {
                ...state,
                vendorTariffsLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_TARIFFS_SUCCESS: {
            return {
                ...state,
                error: null,
                vendorTariffsLoading: false,
                vendorTariffsData: action.payload,
            }
        }
        case type.SOCIETY_GET_VENDOR_TARIFFS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorTariffsLoading: false,
            }

        // Create Vendor Tariff
        case type.SOCIETY_CREATE_VENDOR_TARIFF:
            return {
                ...state,
                createVendorTariffLoading: true,
                error: null,
            }
        case type.SOCIETY_CREATE_VENDOR_TARIFF_SUCCESS: {
            return {
                ...state,
                error: null,
                createVendorTariffLoading: false,
            }
        }
        case type.SOCIETY_CREATE_VENDOR_TARIFF_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createVendorTariffLoading: false,
            }

        // Delete Vendor Tariff
        case type.SOCIETY_DELETE_VENDOR_TARIFF:
            return {
                ...state,
                deleteVendorTariffLoading: true,
                error: null,
            }
        case type.SOCIETY_DELETE_VENDOR_TARIFF_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteVendorTariffLoading: false,
            }
        }
        case type.SOCIETY_DELETE_VENDOR_TARIFF_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteVendorTariffLoading: false,
            }

        // Get All Vendor Tariffs
        case type.SOCIETY_GET_ALL_VENDOR_TARIFFS:
            return { ...state, allVendorTariffsLoading: true, error: null }
        case type.SOCIETY_GET_ALL_VENDOR_TARIFFS_SUCCESS:
            return { ...state, allVendorTariffsLoading: false, allVendorTariffsData: action.payload, error: null }
        case type.SOCIETY_GET_ALL_VENDOR_TARIFFS_FAILURE:
            return { ...state, allVendorTariffsLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR BILLS ============

        // Get Vendor Bills List
        case type.SOCIETY_GET_VENDOR_BILLS_LIST:
            return {
                ...state,
                vendorBillsListLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_BILLS_LIST_SUCCESS: {
            const raw = action.payload?.data;
            // BE returns { bills, vendorSettings, ... } on the /bills/list route.
            const rows = raw?.bills || raw?.rows || raw || action.payload?.rows || action.payload?.bills || action.payload;
            const paginationMeta = action.payload?.meta?.pagination;
            const fallbackTotal = action.payload?.count || (Array.isArray(rows) ? rows.length : 0);
            return {
                ...state,
                error: null,
                vendorBillsListLoading: false,
                vendorBillsListData: rows,
                vendorSettings: raw?.vendorSettings || state.vendorSettings,
                vendorBillsPagination: paginationMeta || {
                    total: fallbackTotal,
                    totalPages: Math.ceil(fallbackTotal / 10)
                },
            }
        }
        case type.SOCIETY_GET_VENDOR_BILLS_LIST_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorBillsListLoading: false,
            }

        // Get Vendor Bill Details
        case type.SOCIETY_GET_VENDOR_BILL_DETAILS:
            return {
                ...state,
                vendorBillDetailsLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_VENDOR_BILL_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                vendorBillDetailsLoading: false,
                vendorBillDetailsData: action.payload,
            }
        }
        case type.SOCIETY_GET_VENDOR_BILL_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                vendorBillDetailsLoading: false,
            }

        // Create Vendor Bill
        case type.SOCIETY_CREATE_VENDOR_BILL:
            return {
                ...state,
                createVendorBillLoading: true,
                error: null,
            }
        case type.SOCIETY_CREATE_VENDOR_BILL_SUCCESS: {
            return {
                ...state,
                error: null,
                createVendorBillLoading: false,
            }
        }
        case type.SOCIETY_CREATE_VENDOR_BILL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createVendorBillLoading: false,
            }
        case type.SOCIETY_CREATE_VENDOR_BILLS_BATCH:
            return { ...state, createVendorBillsBatchLoading: true, createVendorBillsBatchError: null }
        case type.SOCIETY_CREATE_VENDOR_BILLS_BATCH_SUCCESS:
            return {
                ...state,
                createVendorBillsBatchLoading: false,
                createVendorBillsBatchResult: action.payload,
                createVendorBillsBatchError: null
            }
        case type.SOCIETY_CREATE_VENDOR_BILLS_BATCH_FAILURE:
            return {
                ...state,
                createVendorBillsBatchLoading: false,
                createVendorBillsBatchError: action?.message || 'Unable to create vendor bills'
            }
        case type.SOCIETY_CREATE_VENDOR_BILLS_BATCH_RESET:
            return {
                ...state,
                createVendorBillsBatchLoading: false,
                createVendorBillsBatchResult: null,
                createVendorBillsBatchError: null
            }

        // Update Vendor Bill
        case type.SOCIETY_UPDATE_VENDOR_BILL:
            return {
                ...state,
                updateVendorBillLoading: true,
                error: null,
            }
        case type.SOCIETY_UPDATE_VENDOR_BILL_SUCCESS: {
            return {
                ...state,
                error: null,
                updateVendorBillLoading: false,
            }
        }
        case type.SOCIETY_UPDATE_VENDOR_BILL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateVendorBillLoading: false,
            }

        // Delete Vendor Bill
        case type.SOCIETY_DELETE_VENDOR_BILL:
            return {
                ...state,
                deleteVendorBillLoading: true,
                error: null,
            }
        case type.SOCIETY_DELETE_VENDOR_BILL_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteVendorBillLoading: false,
            }
        }
        case type.SOCIETY_DELETE_VENDOR_BILL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteVendorBillLoading: false,
            }

        // Approve Vendor Bill
        case type.SOCIETY_APPROVE_VENDOR_BILL:
            return {
                ...state,
                approveVendorBillLoading: true,
                error: null,
            }
        case type.SOCIETY_APPROVE_VENDOR_BILL_SUCCESS: {
            return {
                ...state,
                error: null,
                approveVendorBillLoading: false,
            }
        }
        case type.SOCIETY_APPROVE_VENDOR_BILL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                approveVendorBillLoading: false,
            }

        // Pay Vendor Bill
        case type.SOCIETY_PAY_VENDOR_BILL:
            return {
                ...state,
                payVendorBillLoading: true,
                error: null,
            }
        case type.SOCIETY_PAY_VENDOR_BILL_SUCCESS: {
            return {
                ...state,
                error: null,
                payVendorBillLoading: false,
            }
        }
        case type.SOCIETY_PAY_VENDOR_BILL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                payVendorBillLoading: false,
            }

        // ============ VENDOR BANK ACCOUNTS ============

        // Get Vendor Bank Accounts
        case type.SOCIETY_GET_VENDOR_BANK_ACCOUNTS:
            return { ...state, vendorBankAccountsLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_SUCCESS:
            return { ...state, vendorBankAccountsLoading: false, vendorBankAccountsData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_FAILURE:
            return { ...state, vendorBankAccountsLoading: false, error: action?.message || 'Something went wrong.' }

        // Create Vendor Bank Account
        case type.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT:
            return { ...state, createVendorBankAccountLoading: true, error: null }
        case type.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_SUCCESS:
            return { ...state, createVendorBankAccountLoading: false, error: null }
        case type.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_FAILURE:
            return { ...state, createVendorBankAccountLoading: false, error: action?.message || 'Something went wrong.' }

        // Update Vendor Bank Account
        case type.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT:
            return { ...state, updateVendorBankAccountLoading: true, error: null }
        case type.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_SUCCESS:
            return { ...state, updateVendorBankAccountLoading: false, error: null }
        case type.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_FAILURE:
            return { ...state, updateVendorBankAccountLoading: false, error: action?.message || 'Something went wrong.' }

        // Delete Vendor Bank Account
        case type.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT:
            return { ...state, deleteVendorBankAccountLoading: true, error: null }
        case type.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_SUCCESS:
            return { ...state, deleteVendorBankAccountLoading: false, error: null }
        case type.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_FAILURE:
            return { ...state, deleteVendorBankAccountLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR AMC TRACKER ============

        // Get Vendor AMC List
        case type.SOCIETY_GET_VENDOR_AMC_LIST:
            return { ...state, vendorAmcListLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_AMC_LIST_SUCCESS:
            return { ...state, vendorAmcListLoading: false, vendorAmcListData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_AMC_LIST_FAILURE:
            return { ...state, vendorAmcListLoading: false, error: action?.message || 'Something went wrong.' }

        // Get Vendor AMC Details
        case type.SOCIETY_GET_VENDOR_AMC_DETAILS:
            return { ...state, vendorAmcDetailsLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_AMC_DETAILS_SUCCESS:
            return { ...state, vendorAmcDetailsLoading: false, vendorAmcDetailsData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_AMC_DETAILS_FAILURE:
            return { ...state, vendorAmcDetailsLoading: false, error: action?.message || 'Something went wrong.' }

        // Create Vendor AMC
        case type.SOCIETY_CREATE_VENDOR_AMC:
            return { ...state, createVendorAmcLoading: true, error: null }
        case type.SOCIETY_CREATE_VENDOR_AMC_SUCCESS:
            return { ...state, createVendorAmcLoading: false, error: null }
        case type.SOCIETY_CREATE_VENDOR_AMC_FAILURE:
            return { ...state, createVendorAmcLoading: false, error: action?.message || 'Something went wrong.' }

        // Update Vendor AMC
        case type.SOCIETY_UPDATE_VENDOR_AMC:
            return { ...state, updateVendorAmcLoading: true, error: null }
        case type.SOCIETY_UPDATE_VENDOR_AMC_SUCCESS:
            return { ...state, updateVendorAmcLoading: false, error: null }
        case type.SOCIETY_UPDATE_VENDOR_AMC_FAILURE:
            return { ...state, updateVendorAmcLoading: false, error: action?.message || 'Something went wrong.' }

        // Delete Vendor AMC
        case type.SOCIETY_DELETE_VENDOR_AMC:
            return { ...state, deleteVendorAmcLoading: true, error: null }
        case type.SOCIETY_DELETE_VENDOR_AMC_SUCCESS:
            return { ...state, deleteVendorAmcLoading: false, error: null }
        case type.SOCIETY_DELETE_VENDOR_AMC_FAILURE:
            return { ...state, deleteVendorAmcLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR GL CODES ============

        // Get Vendor GL Codes
        case type.SOCIETY_GET_VENDOR_GL_CODES:
            return { ...state, vendorGlCodesLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_GL_CODES_SUCCESS:
            return { ...state, vendorGlCodesLoading: false, vendorGlCodesData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_GL_CODES_FAILURE:
            return { ...state, vendorGlCodesLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR GL CODE DROPDOWN ============

        case type.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN:
            return { ...state, vendorGlCodeDropdownLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_SUCCESS:
            return { ...state, vendorGlCodeDropdownLoading: false, vendorGlCodeDropdownData: action.payload?.data || action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_FAILURE:
            return { ...state, vendorGlCodeDropdownLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR ROUND OFF GL CODE ============

        // Get Vendor Round Off GL Code
        case type.SOCIETY_GET_VENDOR_ROUND_OFF_GL:
            return { ...state, vendorRoundOffGlLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_ROUND_OFF_GL_SUCCESS:
            return { ...state, vendorRoundOffGlLoading: false, vendorRoundOffGlData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_ROUND_OFF_GL_FAILURE:
            return { ...state, vendorRoundOffGlLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR BILLING SETTINGS ============

        // Get Vendor Billing Settings
        case type.SOCIETY_GET_VENDOR_BILLING_SETTINGS:
            return { ...state, vendorBillingSettingsLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_BILLING_SETTINGS_SUCCESS:
            return { ...state, vendorBillingSettingsLoading: false, vendorBillingSettingsData: action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_BILLING_SETTINGS_FAILURE:
            return { ...state, vendorBillingSettingsLoading: false, error: action?.message || 'Something went wrong.' }

        // Save Vendor Billing Settings
        case type.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS:
            return { ...state, saveVendorBillingSettingsLoading: true, error: null }
        case type.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_SUCCESS:
            return { ...state, saveVendorBillingSettingsLoading: false, error: null }
        case type.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_FAILURE:
            return { ...state, saveVendorBillingSettingsLoading: false, error: action?.message || 'Something went wrong.' }

        // Vendors Dropdown
        case type.SOCIETY_GET_VENDORS_DROPDOWN:
            return { ...state, vendorsDropdownLoading: true }
        case type.SOCIETY_GET_VENDORS_DROPDOWN_SUCCESS:
            return { ...state, vendorsDropdownLoading: false, vendorsDropdownData: action.payload }
        case type.SOCIETY_GET_VENDORS_DROPDOWN_FAILURE:
            return { ...state, vendorsDropdownLoading: false, error: action?.message || 'Something went wrong.' }

        // ============ VENDOR PAYMENTS ============

        // Get Vendor Payments List
        case type.SOCIETY_GET_VENDOR_PAYMENTS_LIST:
            return { ...state, vendorPaymentsListLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_PAYMENTS_LIST_SUCCESS:
            return {
                ...state,
                vendorPaymentsListLoading: false,
                vendorPaymentsListData: action.payload?.data || action.payload?.rows || action.payload,
                vendorPaymentsPagination: action.payload?.meta?.pagination || {
                    total: action.payload?.count || 0,
                    totalPages: Math.ceil((action.payload?.count || 0) / 10)
                },
                error: null
            }
        case type.SOCIETY_GET_VENDOR_PAYMENTS_LIST_FAILURE:
            return { ...state, vendorPaymentsListLoading: false, error: action?.message || 'Something went wrong.' }

        // Get Vendor Payment Details
        case type.SOCIETY_GET_VENDOR_PAYMENT_DETAILS:
            return { ...state, vendorPaymentDetailsLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_SUCCESS:
            return { ...state, vendorPaymentDetailsLoading: false, vendorPaymentDetailsData: action.payload?.data || action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_FAILURE:
            return { ...state, vendorPaymentDetailsLoading: false, error: action?.message || 'Something went wrong.' }

        // Create Vendor Payment
        case type.SOCIETY_CREATE_VENDOR_PAYMENT:
            return { ...state, createVendorPaymentLoading: true, error: null }
        case type.SOCIETY_CREATE_VENDOR_PAYMENT_SUCCESS:
            return { ...state, createVendorPaymentLoading: false, error: null }
        case type.SOCIETY_CREATE_VENDOR_PAYMENT_FAILURE:
            return { ...state, createVendorPaymentLoading: false, error: action?.message || 'Something went wrong.' }

        // Update Vendor Payment
        case type.SOCIETY_UPDATE_VENDOR_PAYMENT:
            return { ...state, updateVendorPaymentLoading: true, error: null }
        case type.SOCIETY_UPDATE_VENDOR_PAYMENT_SUCCESS:
            return { ...state, updateVendorPaymentLoading: false, error: null }
        case type.SOCIETY_UPDATE_VENDOR_PAYMENT_FAILURE:
            return { ...state, updateVendorPaymentLoading: false, error: action?.message || 'Something went wrong.' }

        // Delete Vendor Payment
        case type.SOCIETY_DELETE_VENDOR_PAYMENT:
            return { ...state, deleteVendorPaymentLoading: true, error: null }
        case type.SOCIETY_DELETE_VENDOR_PAYMENT_SUCCESS:
            return { ...state, deleteVendorPaymentLoading: false, error: null }
        case type.SOCIETY_DELETE_VENDOR_PAYMENT_FAILURE:
            return { ...state, deleteVendorPaymentLoading: false, error: action?.message || 'Something went wrong.' }

        // Get Vendor Unpaid Bills
        case type.SOCIETY_GET_VENDOR_UNPAID_BILLS:
            return { ...state, vendorUnpaidBillsLoading: true, error: null }
        case type.SOCIETY_GET_VENDOR_UNPAID_BILLS_SUCCESS:
            return { ...state, vendorUnpaidBillsLoading: false, vendorUnpaidBillsData: action.payload?.bills || action.payload, error: null }
        case type.SOCIETY_GET_VENDOR_UNPAID_BILLS_FAILURE:
            return { ...state, vendorUnpaidBillsLoading: false, error: action?.message || 'Something went wrong.' }

        // ---------------- Vendor bulk Excel upload ----------------
        case type.SOCIETY_BULK_UPLOAD_VENDORS:
            return { ...state, bulkUploadVendorsLoading: true, bulkUploadVendorsError: null }
        case type.SOCIETY_BULK_UPLOAD_VENDORS_SUCCESS:
            return {
                ...state,
                bulkUploadVendorsLoading: false,
                bulkUploadVendorsResult: action.payload,
                bulkUploadVendorsError: null
            }
        case type.SOCIETY_BULK_UPLOAD_VENDORS_FAILURE:
            return {
                ...state,
                bulkUploadVendorsLoading: false,
                bulkUploadVendorsError: action?.message || 'Bulk upload failed'
            }
        case type.SOCIETY_BULK_UPLOAD_VENDORS_RESET:
            return {
                ...state,
                bulkUploadVendorsLoading: false,
                bulkUploadVendorsResult: null,
                bulkUploadVendorsError: null
            }

        // ---------------- Vendor Bill bulk Excel upload ----------------
        case type.SOCIETY_BULK_UPLOAD_VENDOR_BILLS:
            return { ...state, bulkUploadVendorBillsLoading: true, bulkUploadVendorBillsError: null }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_SUCCESS:
            return {
                ...state,
                bulkUploadVendorBillsLoading: false,
                bulkUploadVendorBillsResult: action.payload,
                bulkUploadVendorBillsError: null
            }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_FAILURE:
            return {
                ...state,
                bulkUploadVendorBillsLoading: false,
                bulkUploadVendorBillsError: action?.message || 'Bulk upload failed'
            }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_RESET:
            return {
                ...state,
                bulkUploadVendorBillsLoading: false,
                bulkUploadVendorBillsResult: null,
                bulkUploadVendorBillsError: null
            }

        // ---------------- Vendor Payment bulk Excel upload ----------------
        case type.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS:
            return { ...state, bulkUploadVendorPaymentsLoading: true, bulkUploadVendorPaymentsError: null }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_SUCCESS:
            return {
                ...state,
                bulkUploadVendorPaymentsLoading: false,
                bulkUploadVendorPaymentsResult: action.payload,
                bulkUploadVendorPaymentsError: null
            }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_FAILURE:
            return {
                ...state,
                bulkUploadVendorPaymentsLoading: false,
                bulkUploadVendorPaymentsError: action?.message || 'Bulk upload failed'
            }
        case type.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_RESET:
            return {
                ...state,
                bulkUploadVendorPaymentsLoading: false,
                bulkUploadVendorPaymentsResult: null,
                bulkUploadVendorPaymentsError: null
            }

        default:
            return state
    }
}
